// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InboxOutlinedSvg from "@ant-design/icons-svg/es/asn/InboxOutlined";
import AntdIcon from '../components/AntdIcon';

var InboxOutlined = function InboxOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InboxOutlinedSvg
  }));
};

InboxOutlined.displayName = 'InboxOutlined';
export default React.forwardRef(InboxOutlined);